var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"text"},[_c('p',{staticClass:"paragraph-1 white"},[_vm._v(_vm._s(_vm.$t("TextBand.text")))]),_c('p',{staticClass:"paragraph primary-light-color"},[_vm._v(_vm._s(_vm.$t("TextBand.text-1")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }